'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _CellGallery = require('./CellGallery.scss');var _CellGallery2 = _interopRequireDefault(_CellGallery);
var _cellGalleryParams = require('./cellGalleryParams');var _cellGalleryParams2 = _interopRequireDefault(_cellGalleryParams);
var _CellGalleryItem = require('./CellGalleryItem');var _CellGalleryItem2 = _interopRequireDefault(_CellGalleryItem);
var _MemoizedGallerySwiper = require('./MemoizedGallerySwiper');var _MemoizedGallerySwiper2 = _interopRequireDefault(_MemoizedGallerySwiper);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

CellGalleryWithDotsPagination = function (_Component) {_inherits(CellGalleryWithDotsPagination, _Component);function CellGalleryWithDotsPagination() {var _temp, _this, _ret;_classCallCheck(this, CellGalleryWithDotsPagination);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      activeIndex: 0 }, _this.



































    setSwiperRef = function (ref) {
      _this.swiperRef = ref;
    }, _this.

    resizeThrottler = function () {
      _this.swiperRef.swiper.resize.resizeHandler();
    }, _this.

    handleTransitionEnd = function () {
      if (_this.swiperRef && _this.swiperRef.swiper) {
        var idx = _this.swiperRef.swiper.realIndex;

        if (Number.isInteger(idx)) {
          _this.setState({ activeIndex: _this.swiperRef.swiper.realIndex });
        }
      }
    }, _this.

    goToSlide = function (index) {
      if (_this.swiperRef && _this.swiperRef.swiper) {
        _this.swiperRef.swiper.slideTo(index);
      }
    }, _this.

    handleUpdateSwiper = function () {
      if (_this.swiperRef && _this.swiperRef.swiper) {
        _this.swiperRef.swiper.update();
        _this.resizeThrottler();
        _this.setState({ activeIndex: 0 });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);}CellGalleryWithDotsPagination.prototype.componentDidMount = function componentDidMount() {window.addEventListener('orientationchange', this.resizeThrottler, false);window.addEventListener('resize', this.resizeThrottler);if (this.swiperRef && this.swiperRef.swiper) {this.swiperRef.swiper.update();this.resizeThrottler();}};CellGalleryWithDotsPagination.prototype.shouldComponentUpdate = function shouldComponentUpdate(newProps, newState) {var isRtlChanged = newProps.isRtl !== this.props.isRtl;var isImagesChanged = newProps.images.length !== this.props.images.length;var isActiveIndexChanged = newState.activeIndex !== this.state.activeIndex && !newProps.withoutPagination;return isRtlChanged || isImagesChanged || newProps.withoutLoop || isActiveIndexChanged;};CellGalleryWithDotsPagination.prototype.componentWillUnmount = function componentWillUnmount() {window.removeEventListener('orientationchange', this.resizeThrottler, false);window.removeEventListener('resize', this.resizeThrottler);};

  // renderPagination = () => {
  //   const { images } = this.props;
  //   const { activeIndex } = this.state;

  //   return (
  //     <div className={styles.customPagination}>
  //       {images.map((_, idx) => {
  //         const isActive = idx === activeIndex;
  //         const key = idx;

  //         return (
  //           <span
  //             key={key}
  //             className={cx(styles.bullet, { [styles.active]: isActive })}
  //             onClick={() => this.goToSlide(idx + 1)}
  //           />
  //         );
  //       })}
  //     </div>
  //   );
  // };
  CellGalleryWithDotsPagination.prototype.
  render = function render() {var _props =






    this.props,images = _props.images,isRtl = _props.isRtl,isLazy = _props.isLazy,withoutLoop = _props.withoutLoop,withoutAutoplay = _props.withoutAutoplay;

    var gallerySwiperParams = (0, _cellGalleryParams2.default)({
      className: 'cellGalleryArrow',
      isMobile: true,
      isRtl: isRtl,
      isLazy: isLazy,
      withoutLoop: withoutLoop });


    var params = Object.assign({},
    gallerySwiperParams, {
      rtl: isRtl,
      noSwiping: true,
      initialSlide: 0,
      loop: !withoutLoop,
      on: {
        slideChangeTransitionEnd: this.handleTransitionEnd },

      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        dynamicBullets: images.length > 5 },

      autoplay: !withoutAutoplay && {
        delay: 3000,
        disableOnInteraction: false },

      preloadImages: false,
      lazy: { loadOnTransitionStart: true } });


    return (
      _react2.default.createElement('div', { className: (0, _classnames2.default)(_CellGallery2.default.galleryWrapper, _CellGallery2.default.dotsSlider, this.props.className) },
        this.props.withoutRealEstateSlider ?
        _react2.default.createElement(_CellGalleryItem2.default, { item: images[0] }) :

        _react2.default.createElement('div', { className: _CellGallery2.default.slider },
          _react2.default.createElement(_MemoizedGallerySwiper2.default, _extends({
            onUpdate: this.handleUpdateSwiper,
            setSwiperRef: this.setSwiperRef,
            images: images },
          params)))));





  };return CellGalleryWithDotsPagination;}(_react.Component);exports.default = CellGalleryWithDotsPagination;


CellGalleryWithDotsPagination.propTypes = {
  images: _propTypes2.default.array,
  isRtl: _propTypes2.default.bool,
  withoutLoop: _propTypes2.default.bool,
  withoutPagination: _propTypes2.default.bool,
  isLazy: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  withoutRealEstateSlider: _propTypes2.default.bool,
  withoutAutoplay: _propTypes2.default.bool };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMPropertyCells/components/CellGallery/CellGalleryWithDotsPagination.js
// module id = 2772
// module chunks = 0